import { StaticBaseDao } from '@/dao';
import { SystemStatus } from '@/objects/generated';
import { useUserStore } from '@/stores';

export class SystemStatusDao extends StaticBaseDao {
    public static async GetSystemStatus(lastXSeconds?: number, query?: string | null): Promise<SystemStatus[]> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return [];
        }
        return this.BaseFetchArray(
            SystemStatus,
            `SystemStatus/SystemStatus` +
                '?' +
                (lastXSeconds == undefined ? '' : `lastXSeconds=${lastXSeconds}`) +
                '&' +
                (query == undefined ? '' : `query=${query}`),
            'GET',
        );
    }
}
